import { Injectable, inject } from '@angular/core';
import { ErrorHandlingService } from '../error-handling/error-handling.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SpinnerService } from '../spinner/index';
import { Observable, of } from 'rxjs';
import { HttpHeaderConstants } from '../http-header.constant';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CacheJob, CacheJobType } from '../../models/appcloud/cache-job.model';

@Injectable({
    providedIn: 'root',
})
export class CacheJobService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private CACHE_JOB_URL: string = environment.publicApiHost + '/appcloud/cache-jobs';

    public upsert(
        appinstanceId: number,
        cacheJobType: CacheJobType,
        additionalHeaders: any = {}
    ): Observable<CacheJob> {
        this.#spinnerService.addProcess('CacheJobService.upsert.' + appinstanceId, 'Updating cache job...');
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams().set('appinstanceId', appinstanceId).set('cacheJobType', cacheJobType),
        };

        return this.#http.put<CacheJob>(this.CACHE_JOB_URL, null, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while updating your cache job. Please try again later.'
                );
                return of<CacheJob>();
            }),
            finalize(() => this.#spinnerService.completeProcess('CacheJobService.upsert.' + appinstanceId))
        );
    }
}
